<template>
  <div class="w1200 f16 lin-30">
    <p class="text-center f30 pad40-tb">代付说明</p>
    <p>
      <span class="text-indent">本人/单位</span>【 {{ contInfo.contract1 }} 】 （身份证号/统一社会信用代码：【 {{ contInfo.contract2 }} 】） 不可撤销地同意就【
      {{ contInfo.contract3 }} 】（身份证号/统一社会信用代码：【 {{ contInfo.contract4 }} 】）
      在农信商城（网址：nxinstore.com）上的发生的交易代其向卖家支付订单金额【 {{ contInfo.contract5 }} 】元 。
    </p>
    <p><span class="text-indent">对应交易单号：</span>【 {{ contInfo.contract6 }} 】。</p>
    <p><span class="text-indent">卖家</span>【 {{ contInfo.contract7 }} 】（身份证/统一社会信用代码：【 {{ contInfo.contract8 }} 】）。</p>
    <p class="text-indent-title fb">本人/单位确认:</p>
    <p class="fb text-indent">（1）一经点击同意代付，将上述款项支付至卖家账户，即为完成代付，本人/单位将不得以任何理由撤销代付;</p>
    <p class="fb text-indent">
      （2）上述代付行为为本人/单位真实的意思表示，本人/单位已清楚知悉上述代付行为所代表的含义与法律责任，并自愿承担由此产生的一切责任;
    </p>
    <p class="fb text-indent">（3）因上述代付行为产生的任何纠纷，由本人/单位自行解决，与平台无关。</p>
    <p class="text-indent">本人/单位确认已知悉上述所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿作出上述代付行为。</p>
    <p class="text-indent">
      本人/单位同意本代付说明文件使用杭州尚尚签网络科技有限公司提供的上上签电子签约平台服务通过电子签名以数据电文形式订立，具体出具数字证书的电子认证服务机构（CA,
      Certificate Authority）以实际签署时为准，一经本人/单位单方签署即发生法律效力；
    </p>
    <p class="text-indent">
      本人/单位同意在平台方及杭州尚尚签网络科技有限公司或其合作第三方的服务器上以电子形式保存本文件。本文件经本人/单位通过上述方式签署并于平台系统记录的签约之日起发生法律效力
    </p>
    <div class="text-center pad40-tb">
      <div v-if="basicCaAgreementUrl" class="mar20-b">
        <el-checkbox v-model="basicCaChecked" :disabled="isSign" @change="onBasicCaCheckedChange">
          我已阅读并同意<span class="red pointer" @click.stop="openBasicCaAgreement">《{{ basicCaAgreementName }}》</span>
        </el-checkbox>
      </div>
      <el-button type="primary" :disabled="isSign" @click="sign">我已阅读并同意签署</el-button>
    </div>
    <el-dialog
      title="重要事项提醒"
      :visible.sync="basicCaAuthFileDialogVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      center
      class="basic-ca-auth-file-dialog"
    >
      <div class="basic-ca-auth-file-content">
        <p>1、请打印《企业授权书》并盖章，提供PDF或图片</p>
        <p>2、请保证授权书中<span class="red">被授权人与当前操作人</span>保持一致以免认证失败</p>
        <a class="basic-ca-auth-file-download" :href="basicCaAuthFileTemplateUrl" target="_blank">点击下载《企业授权书》模版</a>
      </div>
      <div slot="footer" class="basic-ca-auth-file-footer">
        <el-button size="medium" type="danger" @click="onBasicCaAuthFileReady">已准备好</el-button>
        <div class="mar10-t">
          <a href="javascript:;" class="red" @click="onBasicCaAuthFileCancel">取消</a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      contractData: {},
      contInfo: {},
      orderId: "",
      pMoneyRecently: "",
      time: 5,
      msg: "",
      isSign: false,
      returnUrl: "",
      basicCaAgreementUrl: "",
      basicCaAgreementName: "",
      basicCaChecked: false,
      basicCaIsAuthFile: false,
      basicCaAuthFileDialogVisible: false,
      basicCaAuthFileTemplateUrl: "https://nfs.nxin.com/cxt/CA_Authorization2606.docx",
      authPcUrl: "",
      isAuth: true,
      tips: "",
    };
  },
  created() {
    if (/(nxin.com)$/.test(window.location.host)) {
      document.domain = "nxin.com";
    }
    if (/(dbn.cn)$/.test(window.location.host)) {
      document.domain = "dbn.cn";
    }
    this.orderId = this.$route.query.orderId;
    if (this.orderId === "" || this.orderId === "undefined") {
      this.isSign = true;
      return;
    }
    this.pMoneyRecently = this.$route.query.pMoneyRecently;
    this.fetchBasicCaAgreement();
    this.$store
      .dispatch("treaty/paymentOnBehalf/queryPaymentOnBehalfTreaty", {
        orderId: this.orderId,
        pMoneyRecently: this.pMoneyRecently,
      })
      .then((data) => {
        this.contractData = data.contractData;
        this.contInfo = JSON.parse(data.contractData.contInfo);
      });
    this.returnUrl = this.$route.query.returnUrl ? decodeURIComponent(this.$route.query.returnUrl) : "";
  },
  methods: {
    async fetchBasicCaAgreement() {
      this.basicCaAgreementUrl = "";
      this.basicCaAgreementName = "";
      this.basicCaChecked = false;
      this.basicCaIsAuthFile = false;
      this.basicCaAuthFileDialogVisible = false;
      const loading = this.$loading({
        lock: true,
        text: "加载中",
      });
      try {
        const { code, data } = await requestApi.post("sctrading/contract/getBasicCa", {
          returnUrl: `${process.env.VUE_APP_APP}v/order/detail/${this.orderId}`,
          orderId: this.orderId,
          pMoneyRecently: this.pMoneyRecently,
          contractType: "proxyPay",
        });
        if (code == "0" && data) {
          if (data.isAuth && !data.isExpired && data.url) {
            window.location.href = data.url;
            return;
          }
          this.authPcUrl = data.authPcUrl || "";
          this.isAuth = data.isAuth;
          this.tips = data.tips || "";
          if (data.url) {
            this.basicCaAgreementUrl = data.url;
            this.basicCaAgreementName = data.name || "";
            this.basicCaIsAuthFile = !!data.isAuthFile;
          }
        }
      } finally {
        loading.close();
      }
    },
    openBasicCaAgreement() {
      if (!this.basicCaAgreementUrl) {
        return;
      }
      if (this.basicCaIsAuthFile) {
        this.basicCaAuthFileDialogVisible = true;
        return;
      }
      window.location.href = this.basicCaAgreementUrl;
    },
    onBasicCaAuthFileReady() {
      this.basicCaAuthFileDialogVisible = false;
      window.location.href = this.basicCaAgreementUrl;
    },
    onBasicCaAuthFileCancel() {
      this.basicCaAuthFileDialogVisible = false;
      this.basicCaChecked = false;
    },
    onBasicCaCheckedChange(val) {
      if (val) {
        this.openBasicCaAgreement();
      }
    },
    checkIsAuth() {
      if (this.isAuth === false || this.isAuth === "false") {
        this.$confirm(this.tips || "请先完成认证", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (this.authPcUrl) {
              const separator = this.authPcUrl.includes("?") ? "&" : "?";
              window.location.href = `${this.authPcUrl}${separator}retUrl=${encodeURIComponent(window.location.href)}`;
            }
          })
          .catch();
        return false;
      }
      return true;
    },
    sign() {
      if (!this.checkIsAuth()) {
        return;
      }
      if (this.basicCaAgreementUrl && !this.basicCaChecked) {
        this.basicCaChecked = true;
        this.openBasicCaAgreement();
        return;
      }
      this.$store
        .dispatch("treaty/paymentOnBehalf/signPaymentOnBehalfTreaty", {
          orderId: this.orderId,
          pMoneyRecently: this.pMoneyRecently,
        })
        .then((data) => {
          this.isSign = true;
          this.$message({
            showClose: true,
            message: data.msg + ", " + this.time + "秒自动关闭!",
            type: "success",
          });
          if (this.returnUrl != null && this.returnUrl != "") {
            window.location.href = this.returnUrl;
            return;
          }
          setTimeout(() => {
            window.opener = null; //关闭窗口时不出现提示窗口
            window.close();
            window.location.href = "about:blank";
          }, 5000);
        });
    },
  },
};
</script>
